/**
 * Tier boundaries for the two rating scales. Dependency-free on purpose, so
 * copy and other light modules can read the figures without importing
 * `restaurantUtils.tsx` (which pulls in SVG assets). Re-exported from
 * `restaurantUtils.tsx`.
 */
export const RATING_THRESHOLDS = {
  internal: {
    most: 86,
    high: 51,
    medium: 17,
    some: -10,
    low: -81,
  },
  google: {
    most: 4.75,
    high: 4.5,
    medium: 3.95,
    some: 3.0,
    low: 2.1,
  }
} as const;
